import { render, staticRenderFns } from "./DenyProfile.vue?vue&type=template&id=66c67009&"
import script from "./DenyProfile.vue?vue&type=script&lang=ts&"
export * from "./DenyProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports